import React, { useRef, useEffect, useState } from "react";
import "../../assets/css/services.css"; // Assurez-vous que ce fichier existe
import { useTranslation } from "react-i18next";
import { FaUtensils, FaFireAlt, FaTools } from "react-icons/fa"; // Importez des icônes

// Importez vos images (assurez-vous que les chemins sont corrects)
import foodStylingImage from "../../assets/image/entre.webp";
import smokehouseImage from "../../assets/image/viande8.webp";
import setupImage from "../../assets/image/table12.webp";
const servicesData = [
    {
        id: "foodDrinks",
        title: "FOOD & DRINKS TABLESTYLINGS",
        shortDescription: "Plus qu'un simple élément décoratif...",
        fullDescription:
            "Plus qu'un simple élément décoratif lors d'un événement, nous donnons le ton à toute l'expérience culinaire...",
        icon: <FaUtensils />,
        image: foodStylingImage,
    },
    {
        id: "smokehouse",
        title: "FROM OUR SMOKEHOUSE",
        shortDescription: "De notre FUMOIR, nous produisons...",
        fullDescription:
            "De notre FUMOIR, nous produisons des viandes grillées et fumées...",
        icon: <FaFireAlt />,
        image: smokehouseImage,
    },
    {
        id: "setup",
        title: "WE SET UP FOR YOU",
        shortDescription: "Que ce soit à l'intérieur ou à l'extérieur...",
        fullDescription:
            "Que ce soit à l'intérieur ou à l'extérieur, nous transformons votre espace en un lieu prestigieux...",
        icon: <FaTools />,
        image: setupImage,
    },
];

export default function Services() {
    const { t } = useTranslation("service");
    const [activeCard, setActiveCard] = useState(null);
    const [isVisible, setIsVisible] = useState(false); // Nouvel état pour la visibilité

    useEffect(() => {
        // Simule un délai pour l'apparition (vous pouvez ajuster la valeur)
        const timeoutId = setTimeout(() => {
            setIsVisible(true);
        }, 300); // 300 millisecondes après le montage

        // Nettoyage du timeout si le composant est démonté avant la fin du délai
        return () => clearTimeout(timeoutId);
    }, []);

    const handleClick = (serviceId) => {
        setActiveCard(serviceId === activeCard ? null : serviceId);
    };

    return (
        <section
            id="Service"
            className={`services-section ${isVisible ? "loaded" : ""}`}
        >
            <div className="services-container">
                <h2 className="services-title">{t("services.title")}</h2>
                <p className="services-subtitle">{t("services.subtitle")}</p>

                <div className="services-grid">
                    {servicesData.map((service) => (
                        <div
                            key={service.id}
                            className={`service-card ${
                                activeCard === service.id ? "active" : ""
                            }`}
                        >
                            <div className="service-card-front">
                                <div className="service-icon">
                                    {service.icon}
                                </div>
                                <h3 className="service-card-title">
                                    {t(`services.${service.id}.title`)}
                                </h3>
                                <p className="service-card-short-description">
                                    {t(`services.${service.id}.description`)}
                                </p>
                                <button
                                    className="service-card-button"
                                    onClick={() => handleClick(service.id)}
                                >
                                    {activeCard === service.id
                                        ? t("services.showLess")
                                        : t("services.learnMore")}
                                </button>
                            </div>
                            <div
                                className="service-card-back"
                                style={{
                                    backgroundImage: `url(${service.image})`,
                                }}
                            >
                                <p className="service-card-full-description">
                                    {t(
                                        `services.${service.id}.fullDescription`
                                    )}
                                </p>
                                <button
                                    className="service-card-button"
                                    onClick={() => handleClick(service.id)}
                                >
                                    {t("services.showLess")}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
